import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['labor'], // 为了获取基础路由
    };
};
export const laborToPathNameMap = {
    // 删除任务
    labor2070: ({ businessKey }) => {
        return commonFunc(`/roster/deleteTaskDetail/?id=${businessKey}`);
    },
};
